import { useState } from "react";
import NewUser from "@components/User/New";
import Profile from "@components/User/Profile";
import LoginOrCreate from "@components/User/LoginOrCreate";
import SendReset from "@components/User/SendReset";

interface LoginCollectionProps {
  defaultEmail?: string;
  hideCreate?: boolean;
  onLoginOrCreate?: () => void;
  onPageChange?: (page: string) => void;
}

export default function LoginCollection({
  defaultEmail,
  hideCreate,
  onLoginOrCreate,
  onPageChange,
}: LoginCollectionProps): JSX.Element | null {
  const [dialogPage, setDialogPage] = useState("loginOrCreate");

  let DialogComp;
  switch (dialogPage) {
    case "loginOrCreate":
      DialogComp = LoginOrCreate;
      break;
    case "newUser":
      DialogComp = NewUser;
      break;
    case "profile":
      DialogComp = Profile;
      break;
    case "sendReset":
      DialogComp = SendReset;
      break;
  }

  return (
    <DialogComp
      defaultEmail={defaultEmail}
      hideCreate={hideCreate}
      onNewUser={onLoginOrCreate}
      onLogin={onLoginOrCreate}
      onPageChange={(page: string) => {
        setDialogPage(page);
        if (onPageChange) onPageChange(page);
      }}
    />
  );
}
